import { render, staticRenderFns } from "./PreventiveTreatment.vue?vue&type=template&id=162bfcf2&scoped=true&"
import script from "./PreventiveTreatment.vue?vue&type=script&lang=js&"
export * from "./PreventiveTreatment.vue?vue&type=script&lang=js&"
import style0 from "./PreventiveTreatment.vue?vue&type=style&index=0&id=162bfcf2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "162bfcf2",
  null
  
)

export default component.exports